import { useEffect, useState } from 'react';

import useUsasClubThirdPartyInvoicesData from '../../../state/clubThirdPartyInvoices/UseUsasClubThirdPartyInvoicesData';

import useBaseUsasClubData from '@usas/ui-web/state/clubBase/UseBaseUsasClubData';

const INITIAL_MODAL_STATE = {
  displayPopUp: false,
  modalTitle: 'Third Party Invoice Member Registrations',
  invoice: {}
};

const useClubThirdPartyInvoices = () => {
  const { baseUsasClubState } = useBaseUsasClubData();
  const { clubThirdPartyInvoiceState, getThirdPartyInvoices } = useUsasClubThirdPartyInvoicesData();
  const [modalState, setModalState] = useState(INITIAL_MODAL_STATE);

  const onEditClicked = (invoice) => {
    setModalState({ ...modalState, displayPopUp: true, invoice: invoice });
  };

  const onModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState(INITIAL_MODAL_STATE);
  };

  useEffect(() => {
    if (baseUsasClubState.isObjLoaded === true && modalState.displayPopUp === false) {
      getThirdPartyInvoices(baseUsasClubState.objData.orgUnitId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUsasClubState, modalState.displayPopUp]);

  return {
    modalState,
    onModalCanceled,
    isLoading: baseUsasClubState.isObjLoading || clubThirdPartyInvoiceState.isArrayLoading,
    clubThirdPartyInvoiceState,
    onEditClicked
  };
};

export default useClubThirdPartyInvoices;